module.exports = "<div class=\"articleContentTitleFormat\">\n    {{contentTitle}}\n    <br/> {{contentSubtitle}}\n</div>\n<div class=\"articlePageContent\" [innerHTML]=\"articleContent\">\n    <!-- {{articleContent}} -->\n</div>\n<div class=\"articlePageContentSub--Header\">\n    Published On:\n</div>\n<div class=\"articlePageContentSub--Content\">\n    {{publishDate}}\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/articleAndPub/articleAndPub.component.html
// module id = ../../../../../src/app/components/articleAndPub/articleAndPub.component.html
// module chunks = main